/* ============================================================
   PROSPER — black & white: nav state, reveal, contact sheet,
   quiz runner and result page. Scoring lives in prosper-assess.js
   (window.PROSPER.recommend / reasons / readout) and is unchanged.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }

  /* ---------- nav: solid after scroll, inverts over dark sections ---------- */
  function initNav() {
    var nav = $('[data-pb-nav]');
    if (!nav) return;
    var sticky = $('[data-pb-sticky]');
    var hero = $('[data-pb-hero]');
    var ticking = false;

    function update() {
      ticking = false;
      var y = window.scrollY || 0;
      nav.classList.toggle('is-solid', y > 24);
      var probe = 32;
      var dark = false;
      $$('[data-pb-tone="dark"]').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top <= probe && r.bottom >= probe) dark = true;
      });
      nav.classList.toggle('is-dark', dark);
      if (sticky) {
        var past = hero ? hero.getBoundingClientRect().bottom < 0 : y > 400;
        sticky.classList.toggle('is-on', past);
      }
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- reveal ---------- */
  function initReveal() {
    var els = $$('.pb-rv');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- contact sheet: columns drift in opposite directions ---------- */
  function initSheet() {
    $$('[data-pb-sheet]').forEach(function (sheet) {
      var cols = $$('.pb-sheet__col', sheet);
      if (!cols.length || reduce) return;
      var frames = $$('.pb-sheet__f:not(.blank)', sheet);
      var visible = false;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(sheet);
      } else { visible = true; }

      var t0 = performance.now();
      function tick(now) {
        if (visible) {
          var t = (now - t0) / 1000;
          var r = sheet.getBoundingClientRect();
          var s = (window.innerHeight - r.top) * 0.08;
          cols.forEach(function (c, i) {
            var dir = i % 2 ? 1 : -1;
            var speed = 9 + (i % 3) * 4;
            c.style.transform = 'translate3d(0,' + (dir * ((t * speed) % 140 + s) - 40).toFixed(1) + 'px,0)';
          });
        }
        window.requestAnimationFrame(tick);
      }
      window.requestAnimationFrame(tick);

      /* one frame "lit" at a time, like the reference reel */
      if (frames.length > 2) {
        var cur = -1;
        window.setInterval(function () {
          if (!visible) return;
          if (cur > -1) frames[cur].classList.remove('lit');
          var n; do { n = Math.floor(Math.random() * frames.length); } while (n === cur);
          cur = n; frames[cur].classList.add('lit');
        }, 1400);
      }
    });
  }

  /* ---------- quiz ---------- */
  function initQuiz(root) {
    var panes = $$('.pb-quiz__pane', root);
    var segs = $$('[data-pb-prog] i', root);
    var bar = $('[data-pb-prog]', root);
    var counter = $('[data-pb-step]', root);
    var live = $('[data-pb-live]', root);
    var back = $('[data-pb-back]', root);
    var resultUrl = root.getAttribute('data-result-url') || '/pages/your-program';
    var total = panes.length;
    var step = 1;
    var answers = {};

    function show(n, focus) {
      step = n;
      panes.forEach(function (p, i) { p.classList.toggle('is-active', i === n - 1); });
      segs.forEach(function (s, i) { s.classList.toggle('is-done', i < n); });
      if (counter) counter.textContent = n;
      if (bar) bar.setAttribute('aria-valuenow', n);
      if (live) live.textContent = 'Question ' + n + ' of ' + total;
      if (back) back.hidden = n === 1;
      if (focus) {
        var first = $('.pb-opt', panes[n - 1]);
        if (first) first.focus({ preventScroll: true });
        var top = root.getBoundingClientRect().top;
        if (top < 0) root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
    }

    function finish() {
      var P = window.PROSPER || {};
      var program = P.recommend ? P.recommend(answers) : 'foundation';
      if (P.saveResult) P.saveResult(answers, program);
      root.classList.add('is-done');
      if (live) live.textContent = 'Finding your program';
      var url = resultUrl + (resultUrl.indexOf('?') > -1 ? '&' : '?') + 'p=' + encodeURIComponent(program);
      window.location.href = url;
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('.pb-opt');
      if (opt && root.contains(opt)) {
        var pane = opt.closest('.pb-quiz__pane');
        var field = pane.getAttribute('data-field');
        var raw = opt.getAttribute('data-v');
        answers[field] = (field === 'exp' || field === 'days' || field === 'commit') ? parseInt(raw, 10) : raw;
        $$('.pb-opt', pane).forEach(function (o) { o.classList.remove('is-sel'); o.setAttribute('aria-pressed', 'false'); });
        opt.classList.add('is-sel');
        opt.setAttribute('aria-pressed', 'true');
        var go = function () { if (step < total) show(step + 1, true); else finish(); };
        if (reduce) go(); else window.setTimeout(go, 220);
        return;
      }
      if (e.target.closest('[data-pb-back]') && step > 1) show(step - 1, true);
    });

    show(1, false);
  }

  /* ---------- result page ---------- */
  function initResult(root) {
    var P = window.PROSPER || {};
    var none = $('[data-pb-none]', root);
    var has = $('[data-pb-has]', root);
    var answers = P.loadAnswers ? P.loadAnswers() : null;
    var qs = null;
    try { qs = new URLSearchParams(window.location.search).get('p'); } catch (e) {}
    var program = null;
    if (answers && P.recommend) program = P.recommend(answers);
    else if (qs) program = qs;
    else if (P.loadProgram) program = P.loadProgram();

    var pane = program ? $('[data-pb-pane="' + program + '"]', root) : null;
    if (!pane) { if (none) none.hidden = false; return; }
    if (has) has.hidden = false;
    pane.hidden = false;

    var list = $('[data-pb-reasons]', pane);
    var reasons = (answers && P.reasons) ? P.reasons(answers, program) : [];
    if (list && reasons.length) {
      reasons.forEach(function (r) { var li = document.createElement('li'); li.textContent = r; list.appendChild(li); });
    } else {
      var rw = $('[data-pb-reasons-wrap]', pane); if (rw) rw.hidden = true;
    }

    var ro = $('[data-pb-readout]', pane);
    var rows = (answers && P.readout) ? P.readout(answers) : [];
    if (ro && rows.length) {
      rows.forEach(function (r) {
        var d = document.createElement('div');
        var dt = document.createElement('dt'); dt.textContent = r.k;
        var dd = document.createElement('dd'); dd.textContent = r.v;
        d.appendChild(dt); d.appendChild(dd); ro.appendChild(d);
      });
    } else {
      var ow = $('[data-pb-readout-wrap]', pane); if (ow) ow.hidden = true;
    }

    var match = $('[data-pb-compare="' + program + '"]', root);
    if (match) {
      match.classList.add('is-match');
      var f = $('[data-pb-flag]', match); if (f) f.hidden = false;
    }
    var retake = $('[data-pb-retake]', root);
    if (retake) retake.addEventListener('click', function () { if (P.clear) P.clear(); });
  }

  function boot() {
    document.documentElement.classList.remove('pb-nojs');
    initNav();
    initReveal();
    initSheet();
    $$('[data-pb-quiz]').forEach(initQuiz);
    $$('[data-pb-result]').forEach(initResult);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
